import { Component, OnInit, inject } from '@angular/core';
import {DataService} from '../../services/data.service';
import {AccessService} from '../../services/access.service';
import moment from 'moment';
import {MessageService} from '../../services/message.service';
import {Router, RouterLink} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {StatusPipe} from "../../pipes/status.pipe";
import {DatePipe, NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    imports: [
        RouterLink,
        StatusPipe,
        DatePipe,
        NgIf,
        NgForOf
    ],
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private messageService = inject(MessageService);
    private router = inject(Router);

    search;
    data;
    stats: any;

    ngOnInit(): void {
        this.search = {
            text: ''
        };
        this.data = {
            new: [],
            in_progress: [],
            completed: [],
        }

        this.dataService.request('Dashboard/getStats').subscribe(response => {
           this.stats = {
               new: 0,
               in_progress: 0,
               done: 0,
               cancelled: 0,
           };
           response.stats.forEach(stats => {
               this.stats[stats.status] = stats.count;
           })
        });

        this.dataService.request('Task/listDashboard', {
            filter: this.search.text,
        }).subscribe(response => {
            this.data = response;

            this.data.new.forEach(entry => {
                entry.due_date_past = moment(entry.due_date).isBefore(moment(), 'day')
            });

            this.data.in_progress.forEach(entry => {
                entry.due_date_past = moment(entry.due_date).isBefore(moment(), 'day')
            });
        });
    }

    showStatus(status: string): void {
        this.messageService.setItem('task_list_status', status);
        this.router.navigate(['/task']);
    }
}
